/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Search_LabelInputs */



/**
* | output |
* | --- |
* | "Search conversation" |
*
* @param {Conversations_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_search_label = /** @type {((inputs?: Conversations_Search_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Search_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zoek gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher une conversation")
	return /** @type {LocalizedString} */ ("Search conversation")
});